import { GeneralError, GeneralErrorCause } from '51trips-frontend-core'
import { enqueueSnackbar } from 'notistack'

import i18next from '../i18n'

function generateErrorMessage(error: GeneralError): string {
  switch (error.cause) {
    case GeneralErrorCause.networkConnection:
      return i18next.t('errors:errors.networkSettings')
    case GeneralErrorCause.forbidden:
      return i18next.t('errors:errors.maxLogInAttempts')
    case GeneralErrorCause.invalidEmail:
      return i18next.t('errors:errors.invalidEmail')
    case GeneralErrorCause.invalidCredentials:
      return i18next.t('errors:errors.invalidCredentials')
    case GeneralErrorCause.emailAlreadyInUse:
      return i18next.t('errors:errors.emailAlreadyExists')
    case GeneralErrorCause.weakPassword:
      return i18next.t('errors:errors.weakPassword')
    case GeneralErrorCause.wrongPassword:
      return i18next.t('errors:errors.incorrectPassword')
    case GeneralErrorCause.userNotFound:
      return i18next.t('errors:errors.userNotFound')
    case GeneralErrorCause.requestCancelled:
      return i18next.t('errors:errors.operationCancelled')
    case GeneralErrorCause.userCancelledOperation:
      return i18next.t('errors:errors.userCancelledOperation')
    case GeneralErrorCause.unknown:
      return i18next.t('errors:errors.errorUnknown')
    case GeneralErrorCause.invalidArgument:
      return i18next.t('errors:errors.badRequest')
    case GeneralErrorCause.deadlineExceeded:
      return i18next.t('errors:errors.operationCancelled')
    case GeneralErrorCause.dataNotFound:
      return i18next.t('errors:errors.fileNotFound')
    case GeneralErrorCause.alreadyExists:
      return i18next.t('errors:errors.fileAlreadyExists')
    case GeneralErrorCause.permissionDenied:
      return i18next.t('errors:errors.missingPermissions')
    case GeneralErrorCause.resourceExhausted:
      return i18next.t('errors:errors.exceededOperationsPermitted')
    case GeneralErrorCause.failedPrecondition:
      return i18next.t('errors:errors.operationRejected')
    case GeneralErrorCause.aborted:
      return i18next.t('errors:errors.operationAborted')
    case GeneralErrorCause.outOfRange:
      return i18next.t('errors:errors.operationCancelled')
    case GeneralErrorCause.unimplemented:
      return i18next.t('errors:errors.operationImplementationFail')
    case GeneralErrorCause.internalServerError:
    case GeneralErrorCause.unavailable:
      return i18next.t('errors:errors.serverError')
    case GeneralErrorCause.dataLoss:
      return i18next.t('errors:errors.corruptData')
    case GeneralErrorCause.unauthenticated:
      return i18next.t('errors:errors.logInRequired')
    case GeneralErrorCause.badRequest:
      return i18next.t('errors:errors.serverError')
    case GeneralErrorCause.invalidSearchQuery:
      return i18next.t('errors:errors.invalidSearchQuery')
    case GeneralErrorCause.invalidImageRouteData:
      return i18next.t('errors:errors.imageRouteData')
    case GeneralErrorCause.unknownImagePickerErrorCode:
      return i18next.t('errors:errors.unknownImagePickerErrorCode')
    case GeneralErrorCause.dynamicLinkinitialLinkError:
      return i18next.t('errors:errors.serviceUnavailableOnDevice')
    case GeneralErrorCause.dynamicLinkBuildFailed:
      return i18next.t('errors:errors.linkCreationFailed')
    case GeneralErrorCause.dynamicLinkNotFound:
      return i18next.t('errors:errors.linkNotFound')
    case GeneralErrorCause.googleLogInNotPossible:
      return i18next.t('errors:errors.logInNotPossible')
    case GeneralErrorCause.googleInvalidCredential:
      return i18next.t('errors:errors.invalidCredentials')
    case GeneralErrorCause.googleLogInPendingCompletion:
      return i18next.t('errors:errors.logInPendingCompletion')
    case GeneralErrorCause.googleRequestCancelled:
      return i18next.t('errors:errors.googleAuthCancelled')
    case GeneralErrorCause.googleUserNotLoggedIn:
      return i18next.t('errors:errors.userNotLoggedIn')
    case GeneralErrorCause.googleUserAlreadyLoggedIn:
      return i18next.t('errors:errors.userLoggedIn')
    case GeneralErrorCause.stripeInvalidPromoCode:
      return i18next.t('errors:errors.promoCode')
    case GeneralErrorCause.stripeInvalidCredentials:
      return i18next.t('errors:errors.invalidCredentials')
    case GeneralErrorCause.agencyNotFound:
      return i18next.t('errors:errors.agencyNotFound')
    case GeneralErrorCause.chatGptCallFailed:
      return i18next.t('errors:errors.generateSummary')
    case GeneralErrorCause.remoteConfigLoadFailed:
      return i18next.t('errors:errors.fetchRemoteConfig')
    default:
      return i18next.t('errors:errors.generalOops')
  }
}

export function userReadableDescription(error: GeneralError | string) {
  console.error(error)
  if (typeof error === 'string') {
    enqueueSnackbar(error, { variant: 'error' })
  } else {
    enqueueSnackbar(generateErrorMessage(error), { variant: 'error' })
  }
}
